import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { Endpoint, IApiResponse, IHttpClientLogin } from 'src/app/models';
import { HttpService } from '../http.service';
import { HTTP_METHOD } from '.';

const CLIENT_LOGIN_ENDPOINT = 'ClientLogin' as Endpoint;

@Injectable({
  providedIn: 'root',
})
export class LoginApiService {
  constructor(private http: HttpService) {}

  /**
   * "Login" occurs after Firebase auth to retrieve user details from cloud DB
   * @returns {Promise<IApiResponse<IHttpClientLogin>>} User data
   */
  clientLogin$(): Observable<IApiResponse<IHttpClientLogin>> {
    return this.http
      .request$<IHttpClientLogin>(HTTP_METHOD.POST, CLIENT_LOGIN_ENDPOINT)
      .pipe(
        catchError((err) => {
          const status = err.status;
          if (status === 404) {
            return throwError(
              () =>
                new Error(
                  'Access denied, check you are logging in with the correct email and have access to view this portal.'
                )
            );
          }
          return throwError(() => err);
        })
      );
  }
}
